import { apiClient, ApiError, getAuthToken } from '@/shared/data/client';
import { getErrorMessage } from '@/shared/data/errors';
import type { OrganisationRole } from '@flowqa/shared';

type AuthAccessContextResponse = {
  orgId: string | null;
  role: OrganisationRole | null;
  hasElevatedAccess: boolean;
};

const toApiError = (err: unknown): ApiError =>
  err instanceof ApiError ? err : new ApiError(getErrorMessage(err));

const ensureToken = (): string => {
  const token = getAuthToken();
  if (!token) {
    throw new ApiError('Not authenticated');
  }
  return token;
};

export const fetchAuthAccessContext = async (
  organisationId?: string | null,
): Promise<AuthAccessContextResponse> => {
  const token = ensureToken();
  try {
    return await apiClient.get<AuthAccessContextResponse>('auth/access-context', {
      token,
      retries: 1,
      orgId: organisationId ?? undefined,
    });
  } catch (err) {
    throw toApiError(err);
  }
};
